<template>
    <v-container class="py-12">
        <v-row>
            <v-col cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">Notificações</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            { text: 'Home', to: '/home' },
                            { text: 'Notificações', disabled: true }
                        ]" />
                    </div>
                    <div class="button-group">
                        <v-btn color="primary" outlined :disabled="!unreadCount" @click="markAllRead">
                            <v-icon left small>mdi-check-all</v-icon>
                            Marcar todas como lidas
                        </v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-card>
            <v-data-table
                :headers="headers"
                :items="notifications"
                :loading="loading"
                :server-items-length="pagination.total"
                :options.sync="options"
                :footer-props="{ 'items-per-page-options': [10, 15, 30, 50] }"
                class="notification-table app-table"
            >
                <template v-slot:item.title="{ item }">
                    <div class="py-2">
                        <div :class="{ 'font-weight-bold': !item.read_at }">{{ item.title }}</div>
                        <div class="mediumGray--text notification-message">{{ item.message }}</div>
                    </div>
                </template>

                <template v-slot:item.created_at="{ item }">
                    {{ formatDate(item.created_at) }}
                </template>

                <template v-slot:item.read_at="{ item }">
                    <v-chip small :color="item.read_at ? 'success' : 'warning'" outlined>
                        {{ item.read_at ? 'Lida' : 'Não lida' }}
                    </v-chip>
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-btn icon small :disabled="!item.url" @click="openNotification(item)">
                        <v-icon small>mdi-open-in-new</v-icon>
                    </v-btn>
                </template>

                <template v-slot:no-data>
                    Nenhuma notificação encontrada.
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>
import axios from "axios";

export default {
    name: "AdminNotificationList",

    data() {
        return {
            loading: false,
            notifications: [],
            unreadCount: 0,
            pagination: {
                total: 0,
            },
            options: {
                page: 1,
                itemsPerPage: 15,
            },
            headers: [
                { text: "Notificação", value: "title", sortable: false },
                { text: "Data", value: "created_at", width: 180, sortable: false },
                { text: "Status", value: "read_at", width: 130, sortable: false },
                { text: "", value: "actions", width: 70, sortable: false, align: "center" },
            ],
        };
    },

    watch: {
        options: {
            handler() {
                this.loadNotifications();
            },
            deep: true,
        },
    },

    created() {
        this.loadNotifications();
        this.loadUnreadCount();
    },

    methods: {
        async loadNotifications() {
            this.loading = true;

            try {
                const response = await axios.get("/api/v2/admin-notifications", {
                    params: {
                        page: this.options.page || 1,
                        limit: this.options.itemsPerPage || 15,
                    },
                });
                const content = response.data && response.data.content ? response.data.content : {};

                this.notifications = content.data || [];
                this.pagination.total = content.total || 0;

                await this.markVisibleRead();
            } catch (error) {
                console.error("Erro ao carregar histórico de notificações:", error);
            } finally {
                this.loading = false;
            }
        },

        async loadUnreadCount() {
            try {
                const response = await axios.get("/api/v2/admin-notifications/unread-count");
                const content = response.data && response.data.content ? response.data.content : {};
                this.unreadCount = content.total || 0;
            } catch (error) {
                console.error("Erro ao carregar contador de notificações:", error);
            }
        },

        async markVisibleRead() {
            const ids = this.notifications
                .filter((notification) => !notification.read_at)
                .map((notification) => notification.id);

            if (!ids.length) return;

            try {
                await axios.patch("/api/v2/admin-notifications/read-many", { ids });
                const readAt = new Date().toISOString();
                this.notifications = this.notifications.map((notification) => {
                    if (!ids.includes(notification.id)) return notification;
                    return { ...notification, read_at: readAt, read: true };
                });
                await this.loadUnreadCount();
            } catch (error) {
                console.error("Erro ao marcar notificações visíveis como lidas:", error);
            }
        },

        async markAllRead() {
            try {
                await axios.patch("/api/v2/admin-notifications/read-all");
                const readAt = new Date().toISOString();
                this.notifications = this.notifications.map((notification) => ({
                    ...notification,
                    read_at: notification.read_at || readAt,
                    read: true,
                }));
                await this.loadUnreadCount();
            } catch (error) {
                console.error("Erro ao marcar todas as notificações como lidas:", error);
            }
        },

        openNotification(notification) {
            if (!notification || !notification.url) return;

            const normalizedUrl = notification.url.replace(/^\/#/, "");
            if (normalizedUrl && normalizedUrl.startsWith("/")) {
                this.$router.push(normalizedUrl).catch(() => {});
            }
        },

        formatDate(value) {
            if (!value) return "";
            return this.$moment(value).format("DD/MM/YYYY HH:mm");
        },
    },
};
</script>

<style scoped lang="scss">
.notification-table {
    cursor: default;
}

.notification-message {
    white-space: normal;
}
</style>
